import React from 'react'
import GeratorBar from './GeratorBar'
import { AppContainer } from './styles'

function App() {
  return (
    <AppContainer>
      <h1>Gerador de CPF</h1>
      <GeratorBar />
    </AppContainer>
  )
}

export default App
